import { makeStyles } from "@material-ui/core";
import { useReducer } from "react";
import CustomTabStyle from "../../componentes/tabs/CustomTabStyle";
import CustomTabs from "../../componentes/tabs/CustomTabs";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import SearchIcon from "@material-ui/icons/Search";
import { useTranslation } from "react-i18next";
import a11yProps from "../../componentes/tabs/a11Props";
import TabPanel from "../../componentes/tabs/TabPanel";
import FormContainer from "../../componentes/form-container/FormContainer";
import { ConsultInput } from "./ConsultInput";
import { ConsultOutput } from "./ConsultOutput";
import { NorthOutlined, SouthOutlined } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
    root: {
        marginRight: 10,
    },
}));

const reducer = (state, data) => {
    return { ...state, ...data }
}

const initialState = {
    id: 0,
    tabValue: 0,
};

const ConsultControl = () => {

    const { t } = useTranslation();
    const classes = useStyles();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { id, tabValue } = state
    const handleTabChange = (event, newValue) => dispatch({ tabValue: newValue });

    return (
        <>
            <FormContainer>
                <CustomTabs
                    value={tabValue}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="client tab"
                >
                    <CustomTabStyle
                        label={t("input")}
                        {...a11yProps(0)}
                        icon={<SouthOutlined fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("output")}
                        {...a11yProps(1)}
                        icon={<NorthOutlined fontSize="small" classes={classes} />} />
                </CustomTabs>
                <TabPanel value={tabValue} index={0}>
                    <ConsultInput updateId={dispatch} />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <ConsultOutput idClient={id} />
                </TabPanel>
            </FormContainer>
        </>
    )
}

export default ConsultControl;